export default "__VITE_ASSET__DUCpWvG1__"